export default __webpack_public_path__ + "static/pic03-bec43531a7ae96cf474a2010ec19a590.jpg";